import { Link } from "react-router-dom";

/**
 * Checkbox de aceptación del aviso de privacidad (Art. 7 D.L. 144).
 */
export default function PrivacyConsentCheckbox({
  checked,
  onChange,
  id = "privacy-consent",
  required = true,
  className = "",
  tone = "agdysa",
}) {
  const linkClass =
    tone === "labsyso"
      ? "text-[#221d52] font-semibold underline underline-offset-2"
      : "text-brand-primary font-semibold underline underline-offset-2";
  const textClass =
    tone === "labsyso" ? "text-[#221d52]/80" : "text-brand-dark/75";

  return (
    <label
      htmlFor={id}
      className={`flex items-start gap-3 text-sm leading-relaxed cursor-pointer ${textClass} ${className}`}
    >
      <input
        id={id}
        type="checkbox"
        required={required}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={`mt-1 shrink-0 ${tone === "labsyso" ? "accent-[#221d52]" : "accent-brand-primary"}`}
      />
      <span>
        Al enviar este <strong>formulario</strong>, confirmo que he leído y acepto el{" "}
        <Link to="/privacidad" target="_blank" rel="noopener noreferrer" className={linkClass}>
          aviso de privacidad
        </Link>
        , incluyendo la finalidad del tratamiento, los destinatarios de mis datos y el uso de
        este punto de recolección.{" "}
        <span className="text-[11px] opacity-70">(Obligatorio)</span>
      </span>
    </label>
  );
}
